import { createContext, useContext, useEffect, useState } from "react";
import { http } from "@/lib/api";

const Ctx = createContext(null);

export const ContentProvider = ({ children }) => {
  const [content, setContent] = useState(null);
  useEffect(() => {
    Promise.all([http.get("/public/content"), http.get("/public/images")])
      .then(([c, i]) => setContent({ ...c.data, images: i.data }))
      .catch(() => setContent({ settings: {}, services: [], courses: [], images: [] }));
  }, []);
  return <Ctx.Provider value={content}>{children}</Ctx.Provider>;
};

export const useContent = () => useContext(Ctx);
